'use client';

import { Modal } from '@sgcmpteltd/uikit-next';
import { clsx as cx } from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';

import { joinSgcmMedia } from '@/utils/url/join/public';

import { rankMap } from '../config';
import {
  GRADE_TO_POINT_LINK,
  ICON_SIZE_IN_PIXEL,
  RANKING_DESCRIPTION,
} from '../constant';
import styles from '../styles.module.scss';

export const RankPopupModel = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpenModal = () => setIsOpen(true);
  const handleCloseModal = () => setIsOpen(false);

  return (
    <>
      <button
        className={styles.buttonRecommendedPriceDesc}
        onClick={handleOpenModal}>
        <Image
          alt="info outline icon image"
          className={cx(
            styles.imageHoverIcon,
          )}
          height={ICON_SIZE_IN_PIXEL}
          src={`${joinSgcmMedia('/public/new-cars/icon/iconOutlineInfo.svg')}`}
          width={ICON_SIZE_IN_PIXEL} />
      </button>
      <Modal
        backdropTransitionDurationMs={200}
        className={cx(styles.containerRoot, styles.isMediumModal)}
        contentClassName={cx(
          styles.containerModalContent,
          styles.containerPiPricelistModal,
        )}
        isBackdropStatic={false}
        isOpen={isOpen}
        title=""
        onClose={handleCloseModal}>
        <div className={styles.containerModelContent}>
          <div className={styles.containerRankToolTip}>
            <div className={styles.textTooltipTitle}>
              {RANKING_DESCRIPTION}
            </div>
            <div>
              <table className={styles.containerRankTable}>
                <colgroup>
                  <col style={{ width: '50%' }} />
                  <col style={{ width: '50%' }} />
                </colgroup>
                <thead>
                  <tr className={styles.containerRankTableHead}>
                    <th className={styles.contentRankTable}>Ranks</th>
                    <th className={styles.contentRankTable}>Points</th>
                  </tr>
                </thead>
                <tbody>
                  {rankMap.map(({ rank, points }) => (
                    <tr
                      key={rank}
                      className={styles.containerRankTableBody}>
                      <td className={styles.contentRankTable}>
                        {rank}
                      </td>
                      <td className={styles.contentRankTable}>
                        &gt;
                        {points}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div>
              More about the ranking system click
              {' '}
              <Link
                className={styles.rankToolTipHereLink}
                href={GRADE_TO_POINT_LINK}
                target="_blank">
                here
              </Link>
              <span>.</span>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
